// Icon names reach us from Desk's icon field, which is a free-text input whose
// "options" link points at fontawesome.com but whose preview renders the value
// Semantic UI style. So both spellings are in the wild and both have to work.
//
//   "user"                        -> fa fa-user
//   "address book"                -> fa fa-address-book
//   "arrow alternate circle down" -> fa fa-arrow-alt-circle-down
//   "user outline"                -> far fa-user
//
// Anything empty falls back to the caller's default rather than rendering a
// blank space where an icon belongs.

const SEMANTIC_WORD_REPLACEMENTS: Record<string, string> = {
  alternate: 'alt'
};

export const DEFAULT_ICON = 'book';

export const getIconClass = (icon?: string | null, fallback: string = DEFAULT_ICON): string => {
  const name = (icon ?? '').trim().toLowerCase() || fallback;

  // Semantic marks Font Awesome's regular style with an "outline" suffix.
  const isOutline = / outline$/.test(name);
  const withoutStyle = name.replace(/ outline$/, '');

  const normalised = withoutStyle
    .split(/[\s-]+/)
    .filter(Boolean)
    .map((word) => SEMANTIC_WORD_REPLACEMENTS[word] ?? word)
    .join('-');

  if (!normalised) {
    return `fa fa-${fallback}`;
  }

  return isOutline ? `far fa-${normalised}` : `fa fa-${normalised}`;
};
